<div class="app-header">
  <!-- Left Logo -->
  <div class="header-part logo-left">
    <img src="../../../../assets/mindmaps.png" alt="OpenPYQ" class="header-logo">
  </div>
  <!-- Right Logo -->
  <div class="header-part logo-right">
    <img src="../../../../assets/Angular.png" alt="Partner Logo" class="header-logo">
  </div>
  <!-- Center Welcome -->
  <div class="header-part welcome-message">
    <span class="welcome-text">MindMaps For UPSC</span>
  </div>
  <!-- User + Logout -->
  <div class="header-part user-section">
    <div class="user-controls">
      <!-- NEW Google Sign-In Component - only shown when not logged in -->
      <div *ngIf="!isLoggedIn" class="gmail-login-container">
        <div>
          <app-google-signin
            buttonId="header-google-signin"
            [buttonOptions]="{ theme: 'outline', size: 'large' }"
            (signInSuccess)="onGoogleSignInSuccess($event)"
            (signInError)="onGoogleSignInError($event)"
            (signOutSuccess)="onGoogleSignOutSuccess()">
          </app-google-signin>
        </div>
      </div>

      <!-- User welcome and logout - only shown when logged in -->
      <div *ngIf="isLoggedIn" class="button-container">
        <!-- Admin Panel button for internal users only -->
        <button *ngIf="isInternalUser" class="admin-button" routerLink="/admin">
          Admin Panel
        </button>

        <div *ngIf="isLoggedIn" class="welcome-user">
          {{ userName }}
        </div>
        <!-- Settings icon -->
        <button class="settings-button" (click)="openSettings()">
          <i class="settings-icon"></i>
        </button>


        <!-- Settings Dropdown -->
        <div class="settings-dropdown" *ngIf="isSettingsDropdownOpen">
          <div class="dropdown-header">
            <div class="user-info">
              <span>{{ userName }}</span>
              <i class="dropdown-arrow"></i>
            </div>
          </div>
          <div class="dropdown-menu">
            <div class="menu-item" (click)="goToSettings()">
              <i class="menu-icon settings-menu-icon"></i>
              <span>Settings</span>
            </div>
            <div class="menu-section">
            </div>

            <div class="menu-item logout" (click)="logout()">
              <i class="menu-icon logout-icon"></i>
              <span>Logout</span>
            </div>
          </div>
        </div>

      </div>


    </div>
  </div>
</div>

<!-- Settings Component -->
<app-settings [isOpen]="isSettingsOpen" (close)="closeSettings()"></app-settings>
